import { EhpcMessage } from "./Messages";
import uuidv4 from 'uuid/v4';

export interface MessageAction {
  type: string;
  payload: EhpcMessage; 
}

export const msgReducer = (state: EhpcMessage[], action: MessageAction): EhpcMessage[] => {
  if (action.type === 'add') {
    if (action.payload.id === undefined) {
      action.payload.id = uuidv4();
    }
    return [
      action.payload,
      ...state
    ];
  }
  if (action.type === 'remove') {
    state.forEach(i => {
      if(i.id === action.payload.id) {
        state.splice(state.indexOf(i),1);
      }
    });
    return [...state];
  }
  return state;
}
